// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles_hero__2qLxU","header":"styles_header__3osmm"};